import { Icon } from "@42.nl/ui";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  collapsed: boolean;
  size?: number;
};

export function Expander({ collapsed, size }: Readonly<Props>) {
  const { t } = useTranslation("translation");
  const title = collapsed
    ? t("translation:EXPANDER.EXPAND")
    : t("translation:EXPANDER.COLLAPSE");

  return (
    <Tooltip title={title}>
      <div className="sg-flex justify-content-start clickable d-print-none">
        <Icon
          icon={collapsed ? "expand_more" : "expand_less"}
          size={size || 42}
          className="expander-icon d-print-none"
        />
      </div>
    </Tooltip>
  );
}
